import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const Wrapper = styled.div`
  text-align: center;
  margin-top: 22px;
  margin-bottom: 22px;
  font-family: "SF Pro Text", "SF Pro Icons", "Helvetica Neue", "Helvetica",
    "Arial", sans-serif;
`;

const Title = styled.p`
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.01em;
  margin-bottom: 20px;
`;

const WrapperContents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const info = styled.p`
  font-size: 12px;
  font-weight: 300;
  color: ${Colors.text_primary};
  font-family: "SF Pro Text", "SF Pro Icons", "Helvetica Neue", "Helvetica",
    "Arial", sans-serif;
`;

const Line = styled.hr`
  width: 426px;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 25px;
`;
const WrapperButtons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 24px;
`;

const Button = styled.button`
  width: 180px;
  height: 41px;
  font-family: "SF Pro Text", "SF Pro Icons", "Helvetica Neue", "Helvetica",
    "Arial", sans-serif;
  border-radius: 2px;
  border: 1px solid ${Colors.primary};
  background-color: ${Colors.primary};
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  :active {
    transform: translateY(1px);
  }
`;

export default {
  Wrapper,
  Title,
  WrapperContents,
  Line,
  WrapperButtons,
  Button,
  info,
};
